export class RuleModel {
  id: string
  name: string
  trigger: TriggerModel
  actions: ActionModel[]
  facilityId: string
  orgId: string
  createdDateTime: any
  updatedDateTime?: Date | null
  createdByStaffId: string
  createdByStaffName: string
}

export enum ConditionTypeEnum {
  dateTimePeriod = 'DateTimePeriod',
  property = 'Property'
}

 // When event executed
export class TriggerModel {
  event: TriggerEventEnum
  conditions: ConditionModel[]
  data: any //additional data of an trigger
}

// then do action
export class ActionModel {
  type: ActionTypeEnum
  data: any //additional data of an action
}

// condition to check before doing an action
export class ConditionModel {
  type: ConditionTypeEnum
}

export class DateTimePeriodConditionModel extends ConditionModel {
  type = ConditionTypeEnum.dateTimePeriod
  after: number
  period: DateTimePeriodEnum
}

export class PropertiesConditionModel extends ConditionModel {
  type = ConditionTypeEnum.property
  properties: PropertyCondition[]
  operator: PropertyConditionOperatorEnum //operator between properties conditions
}

export class PropertyCondition {
  collection: string
  name: string
  type: string
  expectedValue: string
  operator: ConditionOperatorEnum
}

export enum DateTimePeriodEnum {
  day = 'Day',
  week = 'Week',
  month = 'Month'
}

export enum TriggerEventEnum {
  whenEmailTemplateTypeSent = "Other email type is sent",
  whenUserAddedDeleted = "User is added / deleted", // applies to staff(org admin), staff(home admin), resident, family.
  whenCalenderEventAddedDeleted = "Event is added / deleted",
  whenPremiumServiceAddedDeleted = "Premium Service added / deleted"
}


export enum ActionTypeEnum {
  sendEmailTemplateType = "SendEmailTemplateType",
}

export enum PropertyConditionOperatorEnum {
  or = "||",
  and = "&&"
}

export enum ConditionOperatorEnum {
  equal = "==",
  notEqual = "!="
}